import React from 'react';
import { MainAppContainer } from 'screens/shared/style';
import { SideNav, ReportsPageSection, SidebarIcon } from './style';
import { SidebarNavLink } from '../../shared/NavLink';
import Icon from '../../components/Icons';
import { useTranslation } from 'react-i18next';
type ReportsProps = {
  uri: string,
  children: React.ElementType
};

const Reports = (props: ReportsProps) => {
  const { t } = useTranslation();
  return(
    <MainAppContainer>
      <SideNav className="page-subnav">
        <ul className="actionbar">
          <li>
            <SidebarNavLink
              activeMatch={`${props.uri}/incident`}
              to={`${props.uri}/incident`}
            >
              <SidebarIcon>
                <Icon viewBox="0 0 20 20" glyph="report_incident" size="20" />
              </SidebarIcon>
              {t('screens.reports.incidents')}
            </SidebarNavLink>
          </li>
          <li>
            <SidebarNavLink
              activeMatch={`${props.uri}/maintenance`}
              to={`${props.uri}/maintenance`}
            >
              <SidebarIcon>
                <Icon viewBox="0 0 20 20" glyph="report_maintenance" size="20" />
              </SidebarIcon>
              {t('screens.reports.maintenance')}
            </SidebarNavLink>
          </li>
          <li>
            <SidebarNavLink
              activeMatch={`${props.uri}/components`}
              to={`${props.uri}/components`}
            >
              <SidebarIcon>
                <Icon viewBox="0 0 20 20" glyph="report_components" size="20" />
              </SidebarIcon>
              {t('screens.reports.services')}
            </SidebarNavLink>
          </li>
        </ul>
        <div className="footer" />
      </SideNav>
      <ReportsPageSection>{props.children}</ReportsPageSection>
    </MainAppContainer>
  )
};

export default Reports;
